module.exports = __webpack_public_path__ + "img/gh-36330m-4.prt.f6522c72.jpg";